(function ($) {
  $(document).ready(function () {
    const reCalculateHeight = function() {
      let $block = $('.js-total-inner');
      let $body = $('.js-total-body');
      let height = $block.outerHeight();

      $body.css('max-height', height);
    };

    $(window).resize(function() {
      reCalculateHeight();
    });

    setTimeout(function() {
      reCalculateHeight();
    }, 500);

    $(document).on('click', '.js-total-block', function() {
      reCalculateHeight();
      $(this).toggleClass('collapsed');
    });
  });
})(jQuery);
